'use client';

import { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

interface VideoElementProps {
  src: string;
  className?: string;
  scroller: string;
}

const VideoElement = ({ src, className, scroller }: VideoElementProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useGSAP(() => {
    gsap.fromTo(
      videoRef.current,
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: videoRef.current,
          start: 'top 90%',
          scroller: scroller,
        },
      }
    );
  }, []);

  return (
    <video
      ref={videoRef}
      className={className}
      autoPlay
      loop
      muted
      playsInline
      src={src}
      aria-label="Project media video"
    >
      <track
        kind="captions"
        src="/captions/no-audio.vtt"
        srcLang="en"
        label="No spoken audio"
      />
    </video>
  );
};

export default VideoElement;
